module.exports = __webpack_public_path__ + "img/event-atelier-ms-mai-2025.dd3957f.jpg";